import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpRight, Users } from "lucide-react";

export default function CoordinatorTeams() {
  const [teams, setTeams] = useState([]);
  const [cats, setCats] = useState([]);
  const [players, setPlayers] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const catFilter = searchParams.get("cat") || "";

  useEffect(() => {
    (async () => {
      try {
        const [t, c, p] = await Promise.all([api.get("/teams"), api.get("/categories"), api.get("/players")]);
        setTeams(t.data);
        setCats(c.data);
        setPlayers(p.data);
      } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    })();
  }, []);

  const visibleTeams = catFilter ? teams.filter(t => t.category_id === catFilter) : teams;

  return (
    <div>
      <div className="mb-8">
        <div className="overline">Coordinación</div>
        <h1 className="font-heading font-black text-5xl tracking-tighter uppercase mt-2">Equipos del club</h1>
      </div>

      <div className="flex gap-2 flex-wrap mb-6">
        <button data-testid="cat-filter-all" onClick={() => setSearchParams({})} className={`px-4 h-9 border text-xs font-heading uppercase tracking-wider transition-colors ${!catFilter ? "bg-primary text-white border-primary" : "border-border hover:border-primary"}`}>
          Todas
        </button>
        {cats.map(c => (
          <button key={c.id} data-testid={`cat-filter-${c.id}`} onClick={() => setSearchParams({ cat: c.id })}
            className={`px-4 h-9 border text-xs font-heading uppercase tracking-wider transition-colors ${catFilter === c.id ? "bg-primary text-white border-primary" : "border-border hover:border-primary"}`}>
            {c.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {visibleTeams.map((t) => {
          const cat = cats.find(c => c.id === t.category_id);
          const playerCount = players.filter(p => p.team_id === t.id).length;
          return (
            <Link key={t.id} to={`/team/${t.id}`} data-testid={`coord-team-${t.id}`} className="card-tactical p-5 block">
              <div className="overline">{cat?.name}</div>
              <div className="font-heading font-black text-2xl uppercase tracking-tighter mt-1">{t.name}</div>
              <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-sm">
                <span className="text-muted-foreground flex items-center gap-1"><Users size={13} /> {playerCount} jugadores</span>
                <ArrowUpRight size={14} className="text-primary" />
              </div>
            </Link>
          );
        })}
        {visibleTeams.length === 0 && (
          <div className="col-span-full text-center py-12 border border-dashed border-border text-muted-foreground text-sm">Sin equipos en esta categoría.</div>
        )}
      </div>
    </div>
  );
}
